import Component from "@ember/component"
import { get } from "@ember/object"
import type ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"
import type { CardStack, LessonCard } from "@shared/models/card-stack"
import belongsTo from "cc-frontend/helpers/belongs-to"
import FindManyAltogether from "cc-frontend/helpers/find-many-altogether"
import type EmberStore from "cc-frontend/services/ember-store"
import { use } from "ember-could-get-used-to-this"

export default class AdminDetailCardStack extends Component {
  @service("ember-store") declare store: EmberStore
  declare modelToStringify: ObjectProxy<CardStack>

  @belongsTo("modelToStringify", "course") course

  @use cardStackComments = new FindManyAltogether(() => [
    "comment",
    // @ts-expect-error Untyped get
    get(this, "modelToStringify.attributes.commentIds"),
  ])

  @use cardComments = new FindManyAltogether(() => [
    "comment",
    // @ts-expect-error Untyped get
    get(this, "modelToStringify.attributes.cards")?.flatMap(
      (card: LessonCard) => card.attributes.commentIds
    ) ?? null,
  ])

  get cardStackCommentIds(): string[] {
    if (!this.cardStackComments.content) return []
    return this.cardStackComments.content
      .filter((comment) => !comment.attributes.deletedAt)
      .map((comment) => comment.id)
  }

  get cardCommentIds(): string[] {
    if (!this.cardComments.content) return []
    return this.cardComments.content
      .filter((comment) => !comment.attributes.deletedAt)
      .map((comment) => comment.id)
  }
}
